import { DrawerCardModel } from 'models/Drawer';
import { Widget, WidgetCollection } from 'models/WidgetModel';
import { UrlConfig, GridProps, TADateFilter } from './model';
import { defaultSelectedChartValues, defaultWidget, virtualWidget } from './constants';
import { EnterpriseGlobalModel } from 'models/Enterprise/EnterpriseGlobalModel';

export const localStorageKeys: string[] = [];

export const initialGlobalState = {
  // eslint-disable-next-line prettier/prettier
  widgets: <Widget[]>[],
  widgetsList: <WidgetCollection[]>[],
  virtualWidget: virtualWidget,
  diyMode: false,
  customWidget: defaultWidget,
  diySave: false,
  drawerWidgets: <DrawerCardModel[]>[],
  widgetsAvailable: <any[]>[],
  editing: false,
  endpoints: <UrlConfig>{
    getDataSourceTypes: '/GuardRails/datasource-types',
    getChartTypes: '',
    getChartTypesModel: '',
    getData: '',
    getWidgetData: '',
  },
  isConsumer: false,
  searchFilter: '',
  dateFilter: <TADateFilter>{
    start_date: '',
    end_date: '',
    interval_type: '',
  },
  dashboardView: <'chat' | 'survey' | 'text-analytics'>'survey',
  dataSourceType: <string[]>[],
  configDashboard: <GridProps>{
    dashboard: '',
    widgets: [],
    editMode: false,
    external: false,
    workspace: '',
    showDiyToolbox: false,
    useDiyQueryBuilder: false,
    useHtmlExport: false,
    devEnv: false,
    useDiyHierarchyFilters: false,
    useAdvancedFilters: false,
    useDiyShowCopyWidgetButton: true,
    useDiyMetricLevelFilters: false,
    useDiyCrossProgramRollup: false,
    useDiyEngineEnvelopeWrites: false,
    viewId: 0,
    dataSourceTypesAvailable: [],
    urls: {
      getDataSourceTypes: '/GuardRails/datasource-types',
      getChartTypes: '',
      getChartTypesModel: '',
      getData: '',
      getWidgetData: '',
    },
    isCx2Environment: false,
    dataGridFeatureFlag: false, // true if the new data grid is enabled, false if the old one is used
    useConversationAnalysisV2: false,
  },
  selectedDiyChildChart: defaultSelectedChartValues,
  enterpriseGlobalObj: <EnterpriseGlobalModel>{
    options: {
      availableFieldsManagerOptions: [],
    },
    selectedValues: {
      selectedPartitions: [],
      selectedEnterpriseFields: [],
    },
  },
  enterpriseSelectedTrend: <any>null,
  /** Drawer slices of non-Enterprise engine subtypes, keyed by descriptor id (preview input). */
  engineSlices: <Record<string, unknown>>{},
  isDiyWidgetEngine: false,
  savedEnterpriseWidgetId: null as string | null,
};
